module.exports = __webpack_public_path__ + "img/home-bg-1.246ae034.jpg";